import { Case } from '../types';

/**
 * Client financial roll-up for a set of clients — powers the "Total Collected"
 * and "Total Balance" cards on the staff Dashboard and the per-member
 * Collected / Balance columns on the admin Staff page.
 *
 * NOTE: staff pay itself is NOT derived from these numbers. It's a manual
 * running total an admin records on the Staff page (see StaffPayment /
 * staffPayTotal on StaffUser).
 */
export interface OwnerMetrics {
  /** Sum of amountCharged across every case. */
  totalCharged: number;
  /** Sum of all payments received across every case. */
  totalCollected: number;
  /** Outstanding balance = totalCharged − totalCollected. */
  totalBalance: number;
}

type CaseLike = Pick<Case, 'amountCharged' | 'payments'>;
type ClientLike = { cases?: CaseLike[] };

/** Total payments received on a single case. */
export const caseCollected = (c: CaseLike): number =>
  (c.payments || []).reduce((sum, p) => sum + (Number(p.amount) || 0), 0);

/** Aggregate collected / balance across a set of clients. */
export const computeMetrics = (clients: ClientLike[]): OwnerMetrics => {
  let totalCharged = 0;
  let totalCollected = 0;

  for (const client of clients) {
    for (const c of client.cases || []) {
      totalCharged += Number(c.amountCharged) || 0;
      totalCollected += caseCollected(c);
    }
  }

  return {
    totalCharged,
    totalCollected,
    totalBalance: totalCharged - totalCollected,
  };
};
